import { render } from "./CoverPhoto.vue?vue&type=template&id=f06057da&scoped=true"
import script from "./CoverPhoto.vue?vue&type=script&lang=js"
export * from "./CoverPhoto.vue?vue&type=script&lang=js"

import "./CoverPhoto.vue?vue&type=style&index=0&id=f06057da&scoped=true&lang=css"

import exportComponent from "/home/circleci/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f06057da"]])

export default __exports__